/*jslint sloppy: true*/
/*global getResponsiveBreakpoint: true, isElementInViewport: true, jQuery: true */

var Northstar = Northstar || {};

(function ($, window, document) {
  'use strict';

  // Define Northstar app
  Northstar.sticky = {
    attach: function () {
      // console.log('Northstar sticky.js loaded');
      var hasSticky = false;

      // Sidebar ads sticky behavior
      if ($('.sidebar-ads').length) {
        hasSticky = true;
        $(window).on('load resize scroll', function () {
          requestAnimationFrame(function () {
            Northstar.sticky.sticky($('.sidebar-ads'));
          });
        });
      }

      // Venue Detail info box
        if ($('.col-right .sticky-venue').length) {
        hasSticky = true;
        $(window).on('load resize scroll', function () {
          requestAnimationFrame(function () {
              Northstar.sticky.sticky($('.col-right .sticky-venue'));
          });
        });
      }

      // Min height for col-left to support sticky right content
      if (hasSticky === true) {
        Northstar.sticky.minHeight($('.col-right'), $('.col-left'));
      }
    },

    minHeight: function (el, target) {
      target.css('min-height', el.outerHeight());
    },

    sticky: function (el, adj, unstick) {
        if (el.length == 0) return false;        
        el = el.not('[sticky-cloned]');
        var adj = typeof adj !== 'undefined' ? adj : 16,
            size = getResponsiveBreakpoint(),
            topVal = Northstar.menu.getFxdmenuH() + adj,
            scrolly = $(window).scrollTop() + topVal,
            sidebarBottom = el.parent().length ? el.parent().offset().top + el.parent().height() : 0,
        height = 0,
        offset = 0,
        refObj = null;

      // Small sizes, remove sticky and any position values
      if (size == 'xs' || size == 'sm' || typeof unstick !== 'undefined') {
        el.removeClass('sticky');
        el.css({position: '', top: '', bottom: '', width: '', height: ''});
      }
      else {
        // Create clone to reference for positioning
        if (!el.data('sticky-clone')) {
          var clone = el.clone();
          clone.insertAfter(el);
          clone.attr('sticky-cloned', true);
          clone.css({visibility: 'hidden', position: 'absolute', top: el.position().top});
          el.data('sticky-clone', clone);
          refObj = clone;
        }
        else {
          refObj = el.data('sticky-clone');
        }
        offset = refObj.offset();
        height = refObj.outerHeight();

        if ($('.jump-links--fixed').length) {
          scrolly += $('.jump-links--fixed').outerHeight();
          topVal += $('.jump-links--fixed').outerHeight();
        }

        if (scrolly >= offset.top) {
          el.addClass('sticky');
          el.css('top', topVal);

          // Set width equal to parent
          el.css('width', el.parent().width());
          // only apply if has sidebar
          if ( sidebarBottom > 0  && (scrolly + height + adj) >= sidebarBottom) {
            el.css({position: 'absolute', top: '', bottom: 0});
          }
          else {
            el.css({position: '', bottom: 'auto'});
          }
        }
        else {
          el.removeClass('sticky');
          el.css({top: '', width: ''});
        }
      }
    }
  };

  // Initialize our app on document ready
  $(document).ready(Northstar.sticky.attach);

}(jQuery, this, this.document));
